import styled from '@emotion/styled';

export const StyledDatePicker = styled.div<{
  size: 'sm' | 'md' | 'lg';
  border?: boolean;
}>`
    width: ${({ size }) => (size !== 'md' ? '100%' : '256px')};
    position: relative;
    background: #fff;
    border-radius: 80px;
    ${({ border }) => {
      if (border) {
        return `
                border: 1px solid #99A1AF;
            `;
      }
    }};
    padding: ${({ size }) =>
      size === 'sm' ? '3px 6px' : size === 'md' ? '0 4px' : '6px'};
    display: flex;
    justify-content: space-around;
    align-items: center;
    gap: 8px;

    &.open {
        ${({ border }) => {
          if (border) {
            return `
                    border: 1px solid #000;
                    box-shadow: 0px 0px 8px #E4E6EA;
                `;
          }
        }};
    }

    .calendar-icon {
        display: ${({ size }) => (size === 'lg' ? 'block' : 'none')};
        margin-left: 1rem;
    }

    .arrow-icon {

    }

    .date-button {
    }

    .date-button:focus {
        outline: 0 !important;
    }
`;
